import BaseModel from "../BaseModel";
import Customer from "@/Store/ORM/Customer";
export default class Billings extends BaseModel{
    static entity = 'billings';
    static fields(){
        return {
            id: this.attr(null),
            customer_id: this.attr(null),
            bill_overdue: this.attr(null),
            ar_current: this.attr(null),
            ar_total: this.attr(null),
            ar_date: this.attr(null),
            income_current: this.attr(null),
            income_date: this.attr(null),
            discount: this.attr(null),
            user_id: this.attr(null),
            customer: this.belongsTo(Customer, 'customer_id', 'id')
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at']
    }
    static route(){
        return '/billing'
    }
}
